// Module
var code = "<div class=\"col-md-10 col-md-offset-1\"> <h2>An error occurred</h2> <p class=\"lead\"> Access to the Community Portal is not available at this time. Please try again later. </p> <p> <button data-bind=\"click: logout\" class=\"btn btn-primary mt-3\">Logout</button> </p> </div> ";
// Exports
export default code;